import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  encapsulation: ViewEncapsulation.None,
  host: { class: 'pulse-card' },
  selector: 'pulse-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit {
  @Input() showUnderline: boolean;
  @Input() underlined: boolean;

  constructor() {}

  ngOnInit(): void {}
}
